import ReactDOM from 'react-dom'
import React from 'react'
import { Provider } from 'react-redux'
import './i18n'
import { Router, browserHistory } from 'react-router'
import routes from './client/js/router/router_player'
import store from './client/js/store/store'

const app = document.getElementById('app');
ReactDOM.render(
	<Provider store={store}>
		<Router history={browserHistory} routes={routes} />
	</Provider>,
	app,
)
